import React from "react";

const ProgressBar = (props) => {
  const { backgroundColor, completed, dashed } = props;
  const reducedOpacityBackgroundColor = dashed ? backgroundColor.replace("1)", "0.7)") : backgroundColor;

  const containerStyles = {
    height: 20,
    width: '95%',
    backgroundColor: "#e0e0de",
    borderRadius: 50,
    margin: 10,
    ...props.containerStyle
  }

  const fillerStyles = {
    height: '100%',
    width: `${completed}%`,
    maxWidth: '100%',
    backgroundColor: backgroundColor,
    borderRadius: 'inherit',
    textAlign: 'right',
    transition: 'width 1s ease-in-out',
    background: `repeating-linear-gradient(45deg, ${backgroundColor}, ${backgroundColor} 10px, ${reducedOpacityBackgroundColor} 10px, ${reducedOpacityBackgroundColor} 20px)`,
    position: 'relative'
  }

  const labelStyles = {
    padding: 5,
    color: 'white',
    fontWeight: 'bold',
    top: 2,
    position: 'relative'
  }

  return (
    <div style={containerStyles}>
      <div style={fillerStyles}>
        <span style={labelStyles}>{`${completed}%`}</span>
      </div>
    </div>
  );
};

export default ProgressBar;
